import { Card } from '@/entities/auth'
import { CertificationButton } from '@/features/verify-identity'
import { Slot } from '@/shared/lib'

type Props = {
  onCertificationSuccess: (certNum: string) => void
}

export const Certification = ({ onCertificationSuccess }: Props) => {
  return (
    <Card>
      <Slot name="title">휴대폰 번호 인증</Slot>
      <Slot name="description">
        본인확인 후 비밀번호를 다시 설정할 수 있습니다.
        <br />
        아래 버튼을 눌러 본인확인을 해주세요.
      </Slot>
      <Slot name="children">
        <CertificationButton onSuccess={onCertificationSuccess}>
          본인인증
        </CertificationButton>
      </Slot>
    </Card>
  )
}
